import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Response} from '../models/response';
import {catchError, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CardService {

  private generateOrderURL = 'https://apiwrite.retailbizz.io/api/card/save-ipg-order';
  private payNowURL = 'https://apiwrite.retailbizz.io/api/card/pay-now';
  private removeCardURL = 'https://apiwrite.retailbizz.io/api/card/remove-card';
  private updateDefaultCardURL = 'https://apiwrite.retailbizz.io/api/card/update-default';

  constructor(private http: HttpClient) {
  }

  // Generate order ID to redirect to IPG
  generateOrder(accessToken, customerSlug) {

    return this.http.post<Response>(this.generateOrderURL, {
      slug: customerSlug
    }, {headers: {Authorization: 'Bearer ' + accessToken}})
      .pipe(tap(resp => {
        // this.response = resp;

      }), catchError((err) => {
        console.error(err);
        throw err;
      }));
  }

  // Tokenized pay for latest installment :have to pass order ID
  payNow(accessToken, orderRefNumber) {

    return this.http.post<Response>(this.payNowURL, {
      oid: orderRefNumber,
    }, {headers: {Authorization: 'Bearer ' + accessToken}})
      .pipe(tap(resp => {
        // this.response = resp;

      }), catchError((err) => {
        console.error(err);
        throw err;
      }));
  }

  // Remove tokenized card
  removeCard(accessToken, cardCode, customerSlug) {

    return this.http.post<Response>(this.removeCardURL, {
      slug: customerSlug,
      card_code: cardCode
    }, {headers: {Authorization: 'Bearer ' + accessToken}})
      .pipe(tap(resp => {
        // this.response = resp;

      }), catchError((err) => {
        console.error(err);
        throw err;
      }));
  }

  // Update Default tokenized card
  updateDefaultCard(accessToken, cardCode, customerSlug) {

    return this.http.post<Response>(this.updateDefaultCardURL, {
      user_slug: customerSlug,
      card_code: cardCode,
      is_default: 1
    }, {headers: {Authorization: 'Bearer ' + accessToken}})
      .pipe(tap(resp => {
        // this.response = resp;

      }), catchError((err) => {
        console.error(err);
        throw err;
      }));
  }
}
